module.exports = __webpack_public_path__ + "static/img/db-life-img-01@t.7730e30.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/db-life/db-life-img-01@t.jpg
// module id = ZEXy
// module chunks = 0